<!--<amplify-authenticator>-->
<!--  <div>-->
<!--    Restaurants App-->
<!--    <amplify-sign-out></amplify-sign-out>-->
<!--  </div>-->
<!--  &lt;!&ndash; previous code &ndash;&gt;-->
<!--</amplify-authenticator>-->
<div class="mat-app-background basic-container" [ngClass]="theming.theme+ '-theme'">
<!--  <app-pwa-install></app-pwa-install>-->
  <app-home></app-home>
</div>

